import React from 'react';
import ReactDom from 'react-dom';
import  './mtToast.scss';

class MtToast extends React.Component {
  render() {
    return (
      <div  className='mt-toast-wrapper'>
        <div className='mt-toast-content'>
          {this.props.content}
        </div>
      </div>
    );
  }
}
function pop(content) {
  const container = document.createElement('div');
  container.className = 'toastContainer';
  document.body.append(container);
  ReactDom.render(<MtToast content={content}></MtToast>, container);
  setTimeout(() => {
    dismiss();
  }, 2000);
}
function dismiss() {
  const container = document.getElementsByClassName('toastContainer')[0];
  ReactDom.unmountComponentAtNode(container);
  document.body.removeChild(container);
}
export default {
  pop,
}
